export const RETRIEVING_PROFILE_DETAILS = 'RETRIEVING_PROFILE_DETAILS';
export const SUCCESS_RETRIEVING_PROFILE_DETAILS =
  'SUCCESS_RETRIEVING_PROFILE_DETAILS';
export const ERROR_RETRIEVING_PROFILE_DETAILS =
  'ERROR_RETRIEVING_PROFILE_DETAILS';

export const RETRIEVING_PROFILE_COURSES = 'RETRIEVING_PROFILE_COURSES';
export const SUCCESS_RETRIEVING_PROFILE_COURSES =
  'SUCCESS_RETRIEVING_PROFILE_COURSES';
export const ERROR_RETRIEVING_PROFILE_COURSES =
  'ERROR_RETRIEVING_PROFILE_COURSES';

export const RETRIEVING_PROFILE_BADGES = 'RETRIEVING_PROFILE_BADGES';
export const SUCCESS_RETRIEVING_PROFILE_BADGES =
  'SUCCESS_RETRIEVING_PROFILE_BADGES';
export const ERROR_RETRIEVING_PROFILE_BADGES =
  'ERROR_RETRIEVING_PROFILE_BADGES';

export const RETRIEVING_PROFILE_CERTIFICATES =
  'RETRIEVING_PROFILE_CERTIFICATES';
export const SUCCESS_RETRIEVING_PROFILE_CERTIFICATES =
  'SUCCESS_RETRIEVING_PROFILE_CERTIFICATES';
export const ERROR_RETRIEVING_PROFILE_CERTIFICATES =
  'ERROR_RETRIEVING_PROFILE_CERTIFICATES';

export const RETRIEVING_PROFILE_PORTFOLIO_DETAILS =
  'RETRIEVING_PROFILE_PORTFOLIO_DETAILS';
export const SUCCESS_RETRIEVING_PROFILE_PORTFOLIO_DETAILS =
  'SUCCESS_RETRIEVING_PROFILE_PORTFOLIO_DETAILS';
export const ERROR_RETRIEVING_PROFILE_PORTFOLIO_DETAILS =
  'ERROR_RETRIEVING_PROFILE_PORTFOLIO_DETAILS';

export const ERROR_UPDATE_PROFILE_USER_EDUCATION_EXPERIENCE =
  'ERROR_UPDATE_PROFILE_USER_EDUCATION_EXPERIENCE';
export const ERROR_UPDATE_PROFILE_USER_WORK_EXPERIENCE =
  'ERROR_UPDATE_PROFILE_USER_WORK_EXPERIENCE';
export const ERROR_REMOVE_PROFILE_USER_EDUCATION_EXPERIENCE =
  'ERROR_REMOVE_PROFILE_USER_EDUCATION_EXPERIENCE';
export const ERROR_REMOVE_PROFILE_USER_WORK_EXPERIENCE =
  'ERROR_REMOVE_PROFILE_USER_WORK_EXPERIENCE';

export const SUCCESS_UPDATE_EDUCATION_BACKGROUND =
  'SUCCESS_UPDATE_EDUCATION_BACKGROUND';
export const SUCCESS_UPDATE_WORK_BACKGROUND = 'SUCCESS_UPDATE_WORK_BACKGROUND';
